<template>
  <div 
  class="border-l-4"
  :style="discountWarningAccentColor"
  v-if="showAlert">
    <p class="ml-2 text-sm" :style="discountWarningColor">{{ value }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['value', 'showAlert'],
  computed: {
    ...mapGetters("Theme", [
      "discountWarningColor",
      "discountWarningAccentColor",
    ])
  }
}
</script>

<style>

</style>